import React from "react"
const SETTINGS_HEADER_TEXT = "Settings"

const SettingsHeader = () => (
    <div className="settings-header">
        <div className="settings-header-text-container">
            <p>{SETTINGS_HEADER_TEXT}</p>
        </div>
    </div>
)

export default SettingsHeader


// WEBPACK FOOTER //
// ./src/components/settings_header.jsx